import { List, Map, Record, Set } from "immutable";

import createFromJS from "../../createFromJS";
import { SyncUpdateCollectionRecord } from "./SyncUpdateCollectionRecord";

export const SyncStatusRecord = Record({
  documentUpdates: new SyncUpdateCollectionRecord(),
  updatedSettings: null,
  updatedExternalRep: null,
  newPairs: List(),
  disabledFields: Map(),
  disabledFolders: Map(),
  illegalDocumentOrder: false,
  updatedCustomFields: null,
  newFieldOptionPairs: Map(),
  autoIgnoredIds: Set()
});

const data = {
  objects: {
    documentUpdates: "SyncUpdateCollectionRecord",
    updatedSettings: "SyncSettingsRecord",
    updatedExternalRep: "SyncRepresentationRecord",
    newPairs: "List",
    disabledFields: "Map",
    disabledFolders: "Map",
    autoIgnoredIds: "Set"
  },
  collections: {
    newFieldOptionPairs: "Map",
    updatedCustomFields: "SyncCustomFieldRecord"
  }
};
createFromJS.registerCallback("SyncStatusRecord", createFromJS.createNestedCallback(SyncStatusRecord, data));
